// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dbd06872","952":"9050a042"}[chunkId] + ".chunk.js";
};